export default __webpack_public_path__ + "static/media/banner.2c08cb8e.svg";